






























































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { LocaleMixin } from '@/locales/locale-mixin';
import type { Family } from '@/families/models/family';
import { EventTypes } from '@/constants/event-type-constants';
import FamilyActivityTable from '@/families/components/new/FamilyActivityTable.vue';
import { ActionItem } from '@/dashboards/models/action-items-models';
import { TaskFilterUtils, TaskDateFilter } from '@/families/utils/task-filter-utils';
import { getModule } from 'vuex-module-decorators';
import { FamilyHubFiltersStore } from '@/families/stores/family-hub-filters-store';

const familyHubFiltersStore = getModule(FamilyHubFiltersStore);

@Component({
    components: {
        FamilyActivityTable
    }
})
export default class FamilyActivityTasks extends Mixins(LocaleMixin) {
    @Prop() family!: Family;
    @Prop() tasks!: Array<ActionItem>;
    @Prop() pastCount!: number;
    @Prop() todayCount!: number;
    @Prop() futureCount!: number;

    private updatedEvent = EventTypes.UPDATED;
    private dateFiltersChangedEvent = 'date-filters-changed';
private selectedDates: TaskDateFilter[] = [];

mounted() {
    this.selectedDates = [...familyHubFiltersStore.storedToDoDateFilters];
}

loadData() {
    this.$emit(EventTypes.UPDATED);
}

    get noDataText(): string {
        return 'There are no items for the selected time range.';
    }

    hasDate(date: TaskDateFilter): boolean {
        return TaskFilterUtils.hasDateFilter(this.selectedDates, date);
    }

    toggleDate(date: TaskDateFilter): void {
        this.selectedDates = TaskFilterUtils.toggleDateFilter(this.selectedDates, date, false);
    familyHubFiltersStore.setToDoDateFilters(this.selectedDates);

        this.$emit(this.dateFiltersChangedEvent, this.selectedDates);
    }
}
